export class Command<TParams, TResult> {
    // INFO: Hack żeby TSowy type checker, nie gubił informacji o typie.
    public readonly __result__!: TResult;

    public constructor( public readonly params?: TParams) { }
 }

export interface CommandHandler<TCommand extends Command<TParams, TResult>, TParams = TCommand extends Command<any, infer TP> ? TP : unknown, TResult = TCommand extends Command<infer TR, any> ? TR : unknown> {
    handleAsync(command: TCommand, params?: any): Promise<TResult>;
}
